import React from "react";
import { FaFacebookF, FaInstagram, FaXTwitter, FaYoutube } from "react-icons/fa6";
import Logo from "../assets/logo.jpg"; // Trauma Centre logo
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="text-white bg-[#003840] pt-0 mt-10 text-sm font-normal">
            {/* Main Footer Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8 py-10 border-t border-[#00a8cc]">

                {/* Logo + Socials */}
                <div className="flex flex-col">
                    <Link to="/">
                    <img src={Logo} alt="Trauma Centre IMS BHU" className="w-48 mb-4 h-18" />
                    </Link>
                    <p className="mb-2 text-sm font-semibold">SOCIALS MEDIAS</p>
                    <div className="flex gap-4 text-lg">
                        <Link to="https://www.facebook.com/share/19FS4idsha/ "><FaFacebookF className="hover:text-[#FE904D]" /></Link>
                        <Link to="https://x.com/bhuTRAUMACENTRE?t=Hw_BbRxF2C9xJph-DwoYXw&s=08 "><FaXTwitter className="hover:text-[#FE904D]" /></Link>
                    </div>
                </div>

                {/* OPD Timings */}
                <div>
                    <h4 className="mb-2 text-sm font-semibold">OPD TIMINGS</h4>
                    <p className="text-sm leading-relaxed">Monday - Saturday</p>
                    <p className="text-sm">09:00 AM - 05:00 PM</p>
                </div>

                {/* Contact Info */}
                <div>
                    <h4 className="mb-2 text-sm font-semibold">CONTACT US (24×7 AVAILABILITY)</h4>
                    <ul className="space-y-1 text-sm leading-6">
                        <li>+91 9151067160 (Control cum command Desk)</li>
                        <li>+91 9151067171 (Ayushman Bharat Office)</li>
                        <li>+91 0542-2366073, 2366092, 2366187 (Reception)</li>
                        <li>+91 0542-2366187 Extn. 604 (Office)</li>
                    </ul>
                </div>
            </div>

            {/* Footer Bottom Bar */}
            <div className="bg-[#002b32] py-3 border-t border-[#00a8cc] text-center text-xs">
                <div className="flex flex-col items-center justify-center gap-4 mb-2 md:flex-row">
                    <Link to="#" className="hover:text-[#FE904D]">Terms and conditions</Link>
                    <Link to="/privacy-policy" className="hover:text-[#FE904D]">Privacy policy</Link>
                    <Link to="/app-privacy-policy" className="hover:text-[#FE904D]">Patient App Privacy policy</Link>
                </div>
                <p className="text-[11px] text-gray-400">
                    © {new Date().getFullYear()} All Rights Reserved | Designed & Maintained by <span className="text-[#FE904D] font-medium">@SOUL Limited</span>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
